import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExclamation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 20.588C11.45 20.588 10.9792 20.3922 10.5875 20.0005C10.1958 19.6088 10 19.138 10 18.588C10 18.038 10.1958 17.5672 10.5875 17.1755C10.9792 16.7838 11.45 16.588 12 16.588C12.55 16.588 13.0208 16.7838 13.4125 17.1755C13.8042 17.5672 14 18.038 14 18.588C14 19.138 13.8042 19.6088 13.4125 20.0005C13.0208 20.3922 12.55 20.588 12 20.588ZM12 14.588C11.45 14.588 10.9792 14.3922 10.5875 14.0005C10.1958 13.6088 10 13.138 10 12.588V4.58801C10 4.03801 10.1958 3.56718 10.5875 3.17551C10.9792 2.78385 11.45 2.58801 12 2.58801C12.55 2.58801 13.0208 2.78385 13.4125 3.17551C13.8042 3.56718 14 4.03801 14 4.58801V12.588C14 13.138 13.8042 13.6088 13.4125 14.0005C13.0208 14.3922 12.55 14.588 12 14.588Z",
		fill: "#1D1D1D"
	})
});
export default SvgExclamation;
